import actionCreatorFactory from 'typescript-fsa';

import { FormName } from '@topconagriculture/feed-types';

import reduxConfig from '../../../store/config';
import { Zone } from './zones.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/zones');

export const getZonesList = actionCreator.async<{}, Zone[]>('GET_ZONES_LIST');
export const getZoneById = actionCreator.async<{}, Zone>('GET_ZONE_BY_ID');
export const createZone = actionCreator.async<{}, Zone>('CREATE_ZONE');
export const updateZone = actionCreator.async<{}, Zone>('UPDATE_ZONE');
export const deleteZone = actionCreator.async<{ id: string; formName: FormName }, Zone>('DELETE_ZONE');
